<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title"><span class="bold">TankCraft 36</span></h1>
<p class="line">
</p><p class="title1"><span class="bold">PANZER III</span></p>
<p class="title2"><span class="bold">GERMAN ARMY LIGHT TANK</span></p>
<p class="title3"><span class="bold">NORTH AFRICA</span></p>
<p class="title4"><span class="bold">TRIPOLI TO EL ALAMEIN, 1941-1942</span></p>
<p class="author"><span class="bold">Dennis Oliver</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?25426642